import { InMemoryCache } from "@apollo/client";

export const apolloCache: InMemoryCache = new InMemoryCache({
  typePolicies: {},
});
